import { fetchOrders} from './apiService';
    
        export const getOrders = async (orderNumber) => {
          try {
            const response = await fetchOrders(orderNumber);
            return response;
          } catch (error) {
            return error;
            // Handle error...
          }
        };
    
    
        // Other data layer methods...